export default __webpack_public_path__ + "static/sheenLeft-2acec89f15802feb4f6c1ed54d203e70.png";